import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import Admissions from "@/pages/Admissions";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Learn from "@/pages/Learn";
import AdminPortal from "@/pages/Admin";
import StudentLMS from "@/pages/StudentLMS";
import ConsentBanner from "@/components/ConsentBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Standalone (no public layout) */}
          <Route path="/admin/*" element={<AdminPortal />} />
          <Route path="/lms/*" element={<StudentLMS />} />
          {/* Public site with shared layout */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/learn" element={<Learn />} />
          </Route>
        </Routes>
        <ConsentBanner />
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
